'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  HeaderCarouselNext,
  HeaderCarouselPrevious
} from '@components/carousel'
import { Listing } from '@/mongo/services/activity/types'
import { RecentListingCard } from './card'
import { ArrowRightIcon } from 'design-configuration/components'
import { BodyText } from 'design-configuration/components'
import { AllPurposeLink } from '@components/all-purpose-link'
import { OverlineHeader } from '@components/overline-header'
import { DisplayText } from 'design-configuration/components'
import { cn } from '@/lib/utils'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'

interface CarouselProps {
  listings: Listing[]
}

// Add type assertion in the RecentListingCard to treat SerializableListing as Listing
export const ListingsCarousel = ({ listings }: CarouselProps): React.ReactElement => {
  return (
    <div className="overflow-x-hidden overflow-y-visible">
      <Carousel
        opts={{
          align: 'start',
          loop: false,
          skipSnaps: false,
          dragFree: true,
          axis: 'x'
        }}
        className="relative w-full"
      >
        <div className="md:px-md flex items-end justify-between">
          <div>
            <OverlineHeader text="Expand your collection" />
            <div className="gap-x-md flex items-baseline">
              <DisplayText className="mt-sm">Recent listings</DisplayText>
              <AllPurposeLink
                href="/marketplace/activity"
                className={cn('gap-x-xs hidden w-fit items-center sm:flex')}
                onClick={() => {
                  trackButtonClicked(TrackedButtonNames.homeViewMarketplace)
                }}
              >
                <BodyText className="text-on-surface-variant">View marketplace</BodyText>
                <ArrowRightIcon className="w-sm h-sm fill-on-surface-variant" />
              </AllPurposeLink>
            </div>
          </div>
          <div className="gap-x-md flex">
            <HeaderCarouselPrevious />
            <HeaderCarouselNext />
          </div>
        </div>
        <CarouselContent className="py-md">
          {listings.map((listing, index) => (
            <CarouselItem key={index} className="pl-sm basis-full sm:basis-1/3 lg:basis-1/4">
              <RecentListingCard listing={listing} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  )
}
